import '../../core/components/app-root/AppRoot.css';
import './CodeSnippet.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var copyButtonContainer = _7a468({defaultClassName:'_17pa72a1-3-5-0',variantClassNames:{size:{'default':'_17pa72a2-3-5-0',condensed:'_17pa72a3-3-5-0'}},defaultVariants:{size:'default'},compoundVariants:[]});
export var wrapper = '_17pa72a0-3-5-0';